import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Slide,
  Box,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  IoMdCheckmarkCircleOutline,
  IoMdCloseCircleOutline,
} from "react-icons/io";
import {} from "react-icons/io";
import { toast } from "react-toastify";
import Lightbox from "react-awesome-lightbox";
import TabsActions from "../../Actions/TabsActions";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import tabsStore from "../../Stores/TabsStore";
import tabsConstants from "../../Constants/TabsConstants";

const QuestionResponseTable = ({ inspectionItems }) => {
  const { localization } = useLanguageContext();
  const [showLightBox, setShowLightBox] = useState(false);
  const [questionSelectedImage, setQuestionSelectedImage] = useState("");
  return (
    <>
      <TableContainer
        component={Paper}
        className="mt-2 question-response-table"
      >
        <Table className="custom-table">
          {/* ---------every table header -------- */}

          <TableHead>
            <TableRow>
              <TableCell
                className="table-cell no-border-right "
                sx={{ width: "60%" }}
              >
                <strong>{localization.frage}</strong>
              </TableCell>
              <TableCell
                className="table-cell no-border-right text-left "
                sx={{ width: "30%" }}
              >
                <strong>{localization.antwort}</strong>
              </TableCell>
              <TableCell
                className="table-cell no-border-right text-left "
                sx={{ width: "10%" }}
              >
                <strong>{localization.image || "Image"}</strong>
              </TableCell>
              {/* <TableCell
              className="table-cell w-10% text-center"
              sx={{ width: "10%" }}
            >
              <strong>Status</strong>
            </TableCell> */}
            </TableRow>
          </TableHead>
          {/* ------------reusable header ---------- */}
          <TableBody>
            {inspectionItems.map((question, index) => (
              <TableRow key={index} className="question-row">
                <TableCell className="table-cell no-vertical-border">
                  {question.frage}
                </TableCell>
                <TableCell className="table-cell no-vertical-border">
                  {question.antwort}
                </TableCell>
                <TableCell className="table-cell no-vertical-border">
                  <div className="mt-2">
                    {question.images && question.images.length > 0 && (
                      <img
                        src={
                          "data:image/jpg;base64," +
                          question.images[0].documentAsString
                        }
                        alt={""}
                        className="thumbnailPreview"
                        loading="lazy"
                        style={{ width: "50px" }}
                        onClick={() =>
                          setQuestionSelectedImage(
                            "data:image/jpg;base64," +
                              question.images[0].documentAsString
                          ) & setShowLightBox(true)
                        }
                      />
                    )}
                  </div>
                </TableCell>
                {showLightBox && (
                  <Lightbox
                    allowReset={false}
                    onClose={() => setShowLightBox(false)}
                    image={questionSelectedImage}
                  ></Lightbox>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

const DetailInspectionView = ({
  open,
  onClose,
  inspectionDetails,
  inspectionId,
  equipmentDetails,
  isUserLogged,
}) => {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [checklistData, setChecklistData] = useState([]);
  const [reportData, setReportData] = useState("");
  const [isLightBoxVisible, setIsLightBoxVisible] = useState(false);
  const [inspectionImage, setInspectionImage] = useState([]);
  const [imagesSrc, setImagesSrc] = useState([]);
  const [noImage, setNoImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [feedBack, setFeedback] = useState("");

  useEffect(() => {
    if (inspectionId != "") {
      setGlobalSpinner(true);
      TabsActions.getAuftragDetailsByAuftrageId(inspectionId);
      TabsActions.getInspectionImage(inspectionId);
    }
    return () => {};
  }, [inspectionId]);

  useEffect(() => {
    function getInspectionDetailsByIDSuccess() {
      const res = tabsStore.getResult();
      if (res) {
        setChecklistData(res.checklistChapterModels);
        setFeedback(res.feedBack);
      }
      setGlobalSpinner(false);
    }
    function getInspectionDetailsByIDFailure() {
      const res = tabsStore.getOrderStatusResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    tabsStore.addChangeListener(
      tabsConstants.GET_AUFTRAGSDETAILBYID_SUCCESS,
      getInspectionDetailsByIDSuccess
    );
    tabsStore.addChangeListener(
      tabsConstants.GET_AUFTRAGSDETAILBYID_FAILURE,
      getInspectionDetailsByIDFailure
    );
    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_AUFTRAGSDETAILBYID_SUCCESS,
        getInspectionDetailsByIDSuccess
      );
      tabsStore.removeChangeListener(
        tabsConstants.GET_AUFTRAGSDETAILBYID_FAILURE,
        getInspectionDetailsByIDFailure
      );
    };
  }, []);

  const downLoadReport = () => {
    setGlobalSpinner(true);
    TabsActions.pruefberichtGenerieren(inspectionId);
  };

  useEffect(() => {
    function downloadReportSuccess() {
      var res = tabsStore.getResult();
      if (res) {
        setReportData(res);
      }
      setGlobalSpinner(false);
    }

    function downloadReportFailure() {
      var res = tabsStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    tabsStore.addChangeListener(
      tabsConstants.GENERIERT_PRUEFBERICHT_SUCCESS,
      downloadReportSuccess
    );

    tabsStore.addChangeListener(
      tabsConstants.GENERIERT_PRUEFBERICHT_FAILURE,
      downloadReportFailure
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GENERIERT_PRUEFBERICHT_SUCCESS,
        downloadReportSuccess
      );

      tabsStore.removeChangeListener(
        tabsConstants.GENERIERT_PRUEFBERICHT_FAILURE,
        downloadReportFailure
      );
    };
  }, []);

  useEffect(() => {
    if (reportData != "" && reportData !== null && reportData !== undefined) {
      const url = window.URL.createObjectURL(reportData);
      let a = document.createElement("a");

      a.href = url;
      a.download = "B_Pruefbericht.pdf";
      a.click();
    }

    //  return ()=>{setPruefbericht(null);}
  }, [reportData]);

  function handleLightBox(e, _value) {
    e.preventDefault();
    setSelectedImage(_value);
    setIsLightBoxVisible(true);
  }

  useEffect(() => {
    let image = [];
    if (inspectionImage.length > 0) {
      inspectionImage.map((item) => {
        image.push({ url: `data:image/jpg;base64,${item.documentAsString}` });
      });
      setImagesSrc(image);
    }
  }, [inspectionImage]);

  useEffect(() => {
    function getInspectionImageSuccess() {
      const res = tabsStore.getInspectionImageResult();

      if (res.length > 0) {
        setInspectionImage(res);
      } else {
        setInspectionImage([]);
        setNoImage(true);
      }

      setGlobalSpinner(false);
    }
    function getInspectionImageFailure() {
      const res = tabsStore.getInspectionImageResult();
      setGlobalSpinner(false);
    }
    tabsStore.addChangeListener(
      tabsConstants.GET_INSPECTION_IMAGE_SUCCESS,
      getInspectionImageSuccess
    );
    tabsStore.addChangeListener(
      tabsConstants.GET_INSPECTION_IMAGE_FAILURE,
      getInspectionImageFailure
    );
    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_INSPECTION_IMAGE_SUCCESS,
        getInspectionImageSuccess
      );
      tabsStore.removeChangeListener(
        tabsConstants.GET_INSPECTION_IMAGE_FAILURE,
        getInspectionImageFailure
      );
    };
  }, []);

  function handleLightBoxClose() {
    setIsLightBoxVisible(false);
  }

  useEffect(() => {
    if (isLightBoxVisible) {
      const elem = document.getElementsByClassName("lb-header")[0];
      const rl = elem.getElementsByClassName("rotatel");
      const rR = elem.getElementsByClassName("rotater");
      const zIn = elem.getElementsByClassName("zoomin");
      const zOut = elem.getElementsByClassName("zoomout");
      const close = elem.getElementsByClassName("close");

      rl[0].addEventListener("mouseenter", (event) => {
        event.target.title = localization.rotateLeft;
      });
      rR[0].addEventListener("mouseenter", (event) => {
        event.target.title = localization.rotateRight;
      });
      zIn[0].addEventListener("mouseenter", (event) => {
        event.target.title = localization.zoomIn;
      });

      zOut[0].addEventListener("mouseenter", (event) => {
        event.target.title = localization.zoomOut;
      });
      close[0].addEventListener("mouseenter", (event) => {
        event.target.title = localization.close;
      });

      if (inspectionImage.length > 1) {
        const prev = elem.getElementsByClassName("prev");
        const next = elem.getElementsByClassName("next");
        prev[0].addEventListener("mouseenter", (event) => {
          event.target.title = localization.previous;
        });
        next[0].addEventListener("mouseenter", (event) => {
          event.target.title = localization.nextImage;
        });
      }
    }
  }, [isLightBoxVisible]);

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="md"
        className="inspection-dialog"
      >
        <DialogTitle>
          <Typography variant="h4">{localization.inspectionDetails}</Typography>
          <Typography
            variant="body1"
            className="mt-2"
            color="text.secondary"
            fontSize="small"
          >
            {localization.inspectionFrom} {inspectionDetails?.endDate}
          </Typography>
        </DialogTitle>

        <DialogContent>
          <Typography variant="h5" className="d-flex inspectionStatusTitle">
            {inspectionDetails?.nio.toLowerCase() == "true" ? (
              <IoMdCloseCircleOutline className="mr-1" size={22} color="red" />
            ) : (
              <IoMdCheckmarkCircleOutline
                className="mr-1"
                size={22}
                color="green"
              />
            )}
            {inspectionDetails?.nio.toLowerCase() == "true"
              ? localization.failedInspection
              : localization.passedInspection}
          </Typography>
          <Typography
            variant="body1"
            className="mt-2"
            color="text.secondary"
            fontSize="small"
          >
            {localization.conductedOn} {inspectionDetails?.endDate}{" "}
            {(isUserLogged || !equipmentDetails) &&
              inspectionDetails?.pruefer && (
                <>
                  {localization.by} {inspectionDetails?.pruefer}
                </>
              )}
          </Typography>
          {(isUserLogged || !equipmentDetails) && (
            <div className="inspection-checklist-container pl-0 pr-0">
              <div className="checklist-info">
                <Typography variant="h5">
                  {localization.checklistInfo}
                </Typography>
                <div>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    fontSize="medium"
                  >
                    {localization.name}:
                  </Typography>
                  <strong>{inspectionDetails?.checklistTitle}</strong>
                </div>
                <div>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    fontSize="medium"
                  >
                    {localization.zyklusLabel}:
                  </Typography>
                  <strong>{inspectionDetails?.frequency}</strong>
                </div>
                <div>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    fontSize="medium"
                  >
                    {localization.nextCheckDate}:
                  </Typography>
                  <strong>{inspectionDetails?.nextCheckDate}</strong>
                </div>
              </div>
              <div className="inspection-details">
                <Typography variant="h5">
                  {localization.inspectionDetails}
                </Typography>
                <div>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    fontSize="medium"
                  >
                    {localization.date}:
                  </Typography>
                  <strong>{inspectionDetails?.endDate}</strong>
                </div>
                <div>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    fontSize="medium"
                  >
                    {localization.prueferLabel}:
                  </Typography>
                  <strong>{inspectionDetails?.pruefer}</strong>
                </div>
                <div>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    fontSize="medium"
                  >
                    {localization.status}:
                  </Typography>
                  <strong>
                    {inspectionDetails?.nio.toLowerCase() == "true" ? (
                      <IoMdCloseCircleOutline
                        className="mr-1"
                        size={20}
                        color="red"
                      />
                    ) : (
                      <IoMdCheckmarkCircleOutline
                        className="mr-1"
                        size={20}
                        color="green"
                      />
                    )}
                    {inspectionDetails?.nio.toLowerCase() == "true"
                      ? localization.failed
                      : localization.passed}
                  </strong>
                </div>
              </div>
            </div>
          )}

          <Typography variant="h6" className="mt-3">
            {localization.inspectionQuestions}
          </Typography>

          {checklistData &&
            checklistData.map((chapter, chapterIndex) => {
              return (
                <>
                  <Typography variant="body2" className="mt-4">
                    {chapter.title}
                  </Typography>
                  {chapter.checklistBlockModels.map((block, blockIndex) => {
                    return (
                      <>
                        <Typography variant="body2" className="mt-4">
                          {block.title}
                        </Typography>
                        <QuestionResponseTable
                          inspectionItems={block.answers}
                        />
                      </>
                    );
                  })}
                </>
              );
            })}
          <br></br>
          {(isUserLogged ||
            !equipmentDetails ||
            equipmentDetails.inspectionDisplaySetting == "FullDetails") && (
            <>
              <Typography variant="h6" className="mt-3">
                {localization.inspectionImages}
              </Typography>
              <Typography
                className="mt-4 pl-5 pr-4 text-justify mb-5"
                variant="body2"
              >
                <div className="row ml-0 mt-2">
                  {imagesSrc.map((item, index) => {
                    return (
                      <div
                        className="col-2 mt-3 d-block  text-align-center"
                        key={index}
                      >
                        <img
                          className="imageDiv cursorPoint"
                          alt="not Found"
                          src={item.url}
                          onClick={(e) => handleLightBox(e, index)}
                        />
                      </div>
                    );
                  })}
                </div>
                {noImage && (
                  <div className="row ml-0 mt-3 mb-3 text-center">
                    <div className="col">{localization.noImageAvailable}</div>
                  </div>
                )}
              </Typography>
              {/* -------------Notes------------ */}
              <Typography variant="h6" className="mt-5">
                {localization.notes}
              </Typography>
              <Typography
                className="mt-4 pl-5 pr-4 text-justify mb-5"
                variant="body2"
              >
                {feedBack}
              </Typography>
            </>
          )}
        </DialogContent>

        {/* ------------footer button -------------- */}
        <DialogActions>
          <Button
            onClick={onClose}
            variant="outlined"
            size="large"
            sx={{ textTransform: "none" }}
          >
            {localization.close}
          </Button>
          {(!equipmentDetails || isUserLogged) && (
            <Button
              variant="contained"
              className="containedBtnCls"
              sx={{ textTransform: "none" }}
              size="large"
              onClick={downLoadReport}
            >
              {localization.downloadReport}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {isLightBoxVisible &&
        (inspectionImage.length == 1 ? (
          <Lightbox
            allowReset={false}
            onClose={handleLightBoxClose}
            image={imagesSrc[0].url}
          ></Lightbox>
        ) : (
          <Lightbox
            allowReset={false}
            onClose={handleLightBoxClose}
            images={imagesSrc}
            startIndex={selectedImage}
          ></Lightbox>
        ))}
    </>
  );
};

export default DetailInspectionView;
